<template>
    <div class="container-fluid mt-5 ">
      <div class="row mx-0 mx-lg-4">
        <!-- Colonne pour le texte encapsulé dans FilmCard -->
        <div class="col-md-6 film-texte ">
          <FilmCard v-if="film" :film="film" />
          <p v-else>Film non trouvé.</p>
        </div>
        <!-- Colonne pour les photos -->
        <div class="col-md-6">
          <div v-if="film.photos && film.photos.length" class="d-flex flex-wrap">
            <div v-for="(photo, index) in film.photos" :key="index" class="mb-4">
              <img :src="require(`@/assets/${film.photoDirectory}/${photo}`)" class="img-fluid" alt="Photo du film" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import FilmCard from '@/components/FilmCard.vue';
  
  export default {
    components: {
      FilmCard,
    },
    props: ['id'],
    data() {
      return {
        films: [
          {
            id: 1,
            title: 'Mamma',
            year: '2020',
            duration: '26 min',
            synopsis: `Alors qu'elle menait un combat de tous les jours contre son cancer, je tombe par hasard sur des cassettes vidéo de ma mère : ses voyages, son mariage, ma naissance. Son présent, occulté par la maladie, dissonait avec les archives où je la voyais rayonnante, insouciante, aimante. Sentant que sa vie me filait entre les doigts, avant qu'elle ne s'éteigne, j'ai voulu une dernière fois la faire parler et la photographier en argentique.`,
            crew: {
              'Réalisation, image, son et montage': 'Pablo Cirès',
            },
            festivals_title: 'Séléctions',
            festivals: [
              { name: 'Sélectionné dans le cadre d’Images en Bibliothèque', link: 'https://imagesenbibliotheques.fr/docotheque/mamma-0' },
            ],
            availability: {
              text: 'Disponible en DVD ici',
              link: 'https://bibliotheques-specialisees.paris.fr/ark:/73873/pf0002422525',
            },
            photoDirectory: 'Mamma',
            photos: ['0002_5.jpg', 'F1000013.jpg', 'F1000018.jpg'],
          },
          {
            id: 2,
            title: 'Arcobaleno',
            year: '2026',
            production: 'Les films du Bilboquet',
            coproduction: 'en coproduction avec',
            duration: '81 min',
            synopsis: `Depuis 50 ans, Iolanda est la reine de l’Arcobaleno, un dancing mythique au sud de Rome que tous les jours ses deux fils maintiennent tant bien que mal en vie. Face à un avenir fragile, Elisa, la petite-fille rêve d'une deuxième vie pour l'Arcobaleno, mais convaincre le reste de la famille s'avère plus compliqué qu'il n'y paraît.`,
            crew: {
              'Réalisation, image et son': 'Pablo Cirès',
              'Son': 'Sébastien Pont',
              'Montage': 'Léa Chatauret',
            },
            festivals_title: 'Séléctions',
            festivals: [
              { name: 'Festival Filmer le travail - Compétition internationale - 2026', link: '' },],
            residences: [
              { name: 'Les Pitchs d’Addoc - 2021', link: '' },
              { name: 'Rencontres d’Août – États généraux du documentaire – 2022', link: '' },
              { name: 'Résidence CECI du Moulin d’Andé – 2022', link: '' },
              { name: 'FIPADOC – Pitchs Premiers films européens 2024', link: '' },
              { name: 'Cinéastes en résidence - Périphérie 2024', link: '' },
            ],
            residences_title: 'Résidences',
            // availability: {
            //   text: 'Musique du film disponible ici',
            //   link: 'https://cires.bandcamp.com/',
            // },
            photoDirectory: 'Arcobaleno',
            photos: ['arcobaleno1.jpg','arcobaleno2.jpg','arcobaleno3.jpg',],
          },
        ],
        film: null,
      };
    },
    created() {
        this.loadFilm();
},
watch: {
    // Surveille les changements de la prop `id`
    id() {
      this.loadFilm();
    },
  },

methods: {
    loadFilm() {
      const filmId = parseInt(this.id || this.$route.params.id);
      this.film = this.films.find(f => f.id === filmId);
      if (!this.film) {
        console.error('Film non trouvé');
      }
    }
  },

  mounted() {
    // Réinitialise le scroll en haut de la page quand ce composant est monté
    window.scrollTo(0, 0);
  }
  };
  </script>
  
  <style scoped>
.img-fluid {
  max-width: 100%;
  height: auto;
}

.film-texte{
    text-align: left;
    /* padding-left: 20px; */
}
  </style>